// @flow

import styled from 'styled-components';
import { BOLD } from '../../../helpers/fontWeight';
import type { Theme } from '../../../types';

export default styled<any, Theme>('section')`
  background-color: ${props => props.theme.specifications.backgroundColor};
  border-radius: ${props => props.theme.specifications.borderRadius};
  padding: 2rem;
`;

export const Title = styled<any, Theme>('h3')`
  color: ${props => props.theme.specifications.titleColor};
  font-size: 1.5rem;
  font-weight: ${BOLD};
`;
